export const ENV = "stg";

// API Gateway Entepoint to trigger lambda
export const parcel_api = "https://pmparcelservicesapi.stage.bnidistribution.com"
